module.exports = __webpack_public_path__ + "img/0Q3B7249_WoodMatted.3afe3247.jpg";